module.exports = __webpack_public_path__ + "static/img/asianHandicap_popup_divergence_mb.704d367.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/asianHandicap_popup_divergence_mb.png
// module id = miaH
// module chunks = 1